import { TEST_STATUSES } from '../../../constants';

export const componentName = 'p-TestDetails';

export const progressMessages = {
  [TEST_STATUSES.CREATED]: 'testDetails_creating_use_cases',
  [TEST_STATUSES.RUNNING]: 'testDetails_running_all_use_cases',
  [TEST_STATUSES.EMPTY]: 'testDetails_no_use_case',
} as const;
